import * as React from "react"
import PowerIcon from "../../atoms/icons/PowerIcon"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import { VOLTAGE_FLOAT_DECIMAL_COUNT } from "../../constants"
import { SECTION_SYSTEM_VOLTAGES } from "../../../utils/pages"

const VOLTAGES_TOOLTIP = `
Each power rail powers a set of components in the system. 
Small deviations from the nominal voltage is expected and normal.
Large deviations may cause issues.
`

const VoltagesCard: React.FunctionComponent = () => {
  const { metrics } = useEdgeApi()

  const displayVoltage = (voltage?: number) =>
    voltage ? `${voltage.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} V` : undefined

  return (
    <SettingsOverviewCard title={SECTION_SYSTEM_VOLTAGES.name} icon={<PowerIcon />} tooltip={VOLTAGES_TOOLTIP}>
      <ReadOnlyTextField placeholder="-.- V" label="48V supply" value={displayVoltage(metrics.usePbVoltagesPow48v())} />
      <ReadOnlyTextField placeholder="-.- V" label="5V supply" value={displayVoltage(metrics.usePbVoltagesPow5v())} />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="3.3V supply"
        value={displayVoltage(metrics.usePbVoltagesPow3v3())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="EPOS supply"
        value={displayVoltage(metrics.usePbVoltagesPowEpos())}
      />
      <ReadOnlyTextField placeholder="-.- V" label="TBB supply" value={displayVoltage(metrics.usePbVoltagesPowTbb())} />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="24V isolated supply"
        value={displayVoltage(metrics.usePbVoltagesDig24v())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="5V isolated supply"
        value={displayVoltage(metrics.usePbVoltagesDig5v())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="3.3V isolated supply"
        value={displayVoltage(metrics.usePbVoltagesDig3v3())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="1.8V isolated supply"
        value={displayVoltage(metrics.usePbVoltagesDig1v8())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="1.2V isolated supply"
        value={displayVoltage(metrics.usePbVoltagesDig1v2())}
      />
    </SettingsOverviewCard>
  )
}

export default VoltagesCard
